export default __webpack_public_path__ + "static/media/delete3.d41d6579.svg";